import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import {Owner} from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const owner: Module<Owner, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
